import { render, staticRenderFns } from "./Sorry.vue?vue&type=template&id=3509c91c&scoped=true&"
import script from "./Sorry.vue?vue&type=script&lang=js&"
export * from "./Sorry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509c91c",
  null
  
)

export default component.exports